'use strict';

var $ = require('jquery');
window.jQuery = $; //windows.Jquery creates a global $ intance
require('gwwp');
require('./detail-box');
require('./frontpage');
require('./libs/jquery.rcrumbs.min.js'); //responsive breadcrumbs
require('./header.js');
require('./viewpoint.js'); 
require('./case.js'); 
require('./frontpage.js'); 
require('./svg4everybody.js'); 
require('./libs/iframeResizer.min.js');
require('./iframe-resizer.js');


$(function() {

});
